<template>
  <div>
    <OverlayPanel
      v-on:closeDialog="x"
      :key="componentKey"
      ref="op"
      appendTo="body"
      :showCloseIcon="false"
      id="overlay_panel"
    >
      <div style="" v-if="selectedPresence" class="p-m-1">
        <h5 style="text-align: center" class="p-m-1 p-d-block">
          :המורה המדווח
        </h5>

        <h3 style="text-align: center" class="p-m-1 p-d-block">
          {{ getTeacherObj(selectedPresence.user).firstname }}
          {{ getTeacherObj(selectedPresence.user).lastname }}
        </h3>
        <!--        <h5 style="text-align: center;" class="p-col-3">מורה מדווח</h5>-->
        <Divider type="dashed" class="divider-short-dialog" />
      </div>
      <div v-if="!selectedPresence" class="p-m-1 p-grid p-flex-column">
        <div
          class="p-d-flex p-jc-center"
          v-for="(status, index2) in getPresenceStatus"
          :key="index2"
        >
          <Button
            v-if="status && status.id < 0 && time && time.id === '1'"
            class="presence-button p-col-12 p-m-2"
            :label="status.hebrewName"
            style="text-align: center"
            v-bind:style="`background-color: ${status.color}`"
            @click="update(status)"
          ></Button>
        </div>
      </div>

      <div v-if="selectedPresence" class="p-m-1 p-grid p-flex-column">
        <div
          class="p-d-flex p-jc-center"
          v-for="(status, index2) in getPresenceStatus"
          :key="index2"
        >
          <Button
            v-if="
              status.id < 0 &&
              time.id === '1' &&
              selectedPresence.status.id !== status.id
            "
            class="presence-button p-col-12 p-m-2"
            :label="status.hebrewName"
            style="text-align: center"
            v-bind:style="`background-color: ${status.color}`"
            @click="update(status)"
          />
        </div>
      </div>

      <Divider
        v-if="time && time.id === '1'"
        type="dashed"
        class="divider-short-dialog"
      />

      <div v-if="!selectedPresence" class="p-m-1 p-grid p-flex-column">
        <div
          class="p-d-flex p-jc-center"
          v-for="(status, index2) in getPresenceStatus"
          :key="index2"
        >
          <Button
            style="text-align: center"
            v-if="status.id > 0"
            class="p-col-12 presence-button p-m-2"
            :label="status.hebrewName"
            v-bind:style="`background-color: ${status.color}`"
            @click="update(status)"
          />
        </div>
      </div>
      <div v-if="selectedPresence" class="p-m-1 p-grid p-flex-column">
        <div
          class="p-d-flex p-jc-center"
          v-for="(status, index2) in getPresenceStatus"
          :key="index2"
        >
          <Button
            style="text-align: center"
            v-if="status.id > 0 && selectedPresence.status.id !== status.id"
            class="p-col-12 presence-button p-m-2"
            :label="status.hebrewName"
            v-bind:style="`background-color: ${status.color}`"
            @click="update(status)"
          />
        </div>
      </div>
      <div v-if="selectedPresence" class="p-d-flex p-jc-center p-m-1 p-grid">
        <Divider type="dashed" class="divider-short-dialog" />

        <Button
          class="presence-button p-col-12 p-m-2"
          label="הסר דיווח X"
          :style="`background-color: #bab8b8`"
          @click="update('remove')"
        />
      </div>

      <template #footer> </template>
    </OverlayPanel>
  </div>
</template>

<script>
import Service from "../service/Service";
import { mapState } from "vuex";
import Vue from "vue";

const { v4: uuidv4 } = require("uuid");

export default {
  service: null,
  props: {
    show: Boolean,
    pupil: Object,
    time: Object,
    selectedPresence: Object,
    date: Date,
  },
  created() {
    this.service = new Service();
    this.setNewItemFields();
  },
  computed: {
      getPresenceStatus(){
          return this.presenceStatus.filter(p => p.active)
      },
    ...mapState(["presenceStatus", "teachers", "user"]),
  },
  data() {
    return {
      componentKey: 1,
      newItem: null,
    };
  },

  methods: {
    getTeacherObj(teacherId) {
      return this.teachers.find((teacher) => teacher.id === teacherId);
    },
    x() {
      this.$emit("closeDialog", false);
    },
    close() {},

    async update(status) {
      this.componentKey++;
      if (this.selectedPresence !== null) {
        if (status !== "remove") {
          const pupilObj = JSON.parse(
            JSON.stringify(this.selectedPresence.pupil)
          );
          const timeObj = JSON.parse(
            JSON.stringify(this.selectedPresence.time)
          );
          const statusObj = JSON.parse(
            JSON.stringify(this.selectedPresence.status)
          );
          const RealObj = JSON.parse(JSON.stringify(this.selectedPresence));
          // this.selectedPresence = null
          RealObj.pupil = pupilObj;
          RealObj.time = timeObj;
          RealObj.status = status;
            RealObj.date  = Date.parse(new Date());

            this.$emit("updateItem", RealObj);
          // this.close()

          const demoObj = JSON.parse(JSON.stringify(RealObj));
          demoObj.pupil = RealObj.pupil.id;
          demoObj.time = RealObj.time.id;
          demoObj.status = status.id;
          demoObj.user = this.user.id;
          demoObj.date = Date.parse(new Date());

          await this.service
            .update(demoObj, "presence")
            .then(() => {
              // this.close()
            })
            .catch(() => {
              RealObj.status = statusObj;
              // this.$emit("updateItem", RealObj);
              this.openNotification(
                "danger",
                `אופס`,
                `בעיה בעדכון הנתונים במערכת`
              );
            });
        } else {
          this.$emit("removeItem", this.selectedPresence);
          await this.service
            .delete(this.selectedPresence.id, "presence")
            .then(() => {
              this.close();
            })
            .catch(() => {
              // this.$emit("updateItem", this.selectedPresence);
              this.openNotification(
                "danger",
                `אופס`,
                `בעיה בעדכון הנתונים במערכת`
              );
              this.close();
            });
        }
      } else {
        const newItem = {};
        newItem.id = uuidv4();
        newItem.status = status.id;
        newItem.date = Date.parse(new Date());
          newItem.pupil = this.pupil.id;
        newItem.time = this.time.id;
        newItem.user = this.user.id;

        this.$emit("addItem", JSON.parse(JSON.stringify(newItem)));
        await this.service
          .post(newItem, "presence")
          .then(() => {
            // this.close()
          })
          .catch(() => {
            // this.close()
            // RealObj.status = statusObj
            // this.$emit("updateItem", RealObj);
            // this.openNotification(
            //     "top-right",
            //     "danger",
            //     ` class='bx bx-select-multiple`,
            //     `אופס`,
            //     `בעיה בעדכון הנתונים במערכת`
            // );
          });
      }
    },
    getStatusObj(statusId) {
      return this.presenceStatus.find(
        (presenceStatus) => presenceStatus.id === statusId
      );
    },
    classStatusClass(statusId) {
      return "status-" + statusId;
    },
    setNewItemFields() {
      this.newItem = {
        id: null,
        date: null,
        time: null,
        status: null,
        pupil: null,
        user: null,
        grade: true,
      };
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async post() {},
    openNotification(
      color,
      title,
      text,
      position = "right-left",
      duration = 3000
    ) {
      this.$vs.notification({
        color,
        position,
        title,
        text,
        duration,
        progress: "auto",
      });
    },
  },
};
</script>

<style scoped>
.presence-button {
    justify-content: center;
  border: 1px solid rgba(132, 128, 128, 6.69);
  font-size: medium;
  color: black !important;
}

.presence-button:hover {
  border: 1px solid rgba(132, 128, 128, 6.69) !important;
  transform: scale(1.1, 1.1);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  z-index: 3;
  filter: brightness(1.1);
}
>>>.p-button-label {
    max-width:180px;
}
</style>